export default function DefaultTimeFactory(userService, moment) {
    'ngInject';

        const DEFAULT_TIME_OPTION_INDEX = 18; // 9:00
        const regionalSettings = userService.getRegionalSettings();
        const timeOptions = makeTimeOptions();
        const defaultFormats = {
            date: regionalSettings.dateFormat,
            dateTime: regionalSettings.dateTimeFormat,
            altDateTime: regionalSettings.shortMonthDateTimeFormat,
        };

        return {
            getTimeOptions,
            getDefaultTime,
            defaultFormats,
        };

        function getDefaultTime() {
            return angular.copy(timeOptions[DEFAULT_TIME_OPTION_INDEX]);
        }

        function getTimeOptions() {
            return angular.copy(timeOptions);
        }

        function makeTimeOptions() {
            const totalHalfHours = 48;
            const initialTime = moment().hour(0).minutes(0);
            let totalMinutes = 0;
            const times = [];
            times.push({text: initialTime.format(regionalSettings.timeFormat), value: totalMinutes});
            for (let step = 1; step < totalHalfHours; step++) {
                totalMinutes += 30;
                times.push({
                    text: initialTime.add(30, 'minutes').format(regionalSettings.timeFormat),
                    value: totalMinutes,
                });
            }
            return times;
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/defaultTimeFactory.js